import DatePicker, {Value} from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import React, {MouseEventHandler, useState} from "react";
import CalendarIcon from "../../modules/icons/calendar";
import "react-multi-date-picker/styles/colors/red.css"

interface IRangePicker {
    activeData: string
    setActiveDate: React.Dispatch<React.SetStateAction<string>>
}

const RangePicker = ({activeData, setActiveDate}: IRangePicker) => {
    const [value, setValue] = useState<Value>("");

    function CustomRangeInput(openCalendar: MouseEventHandler<HTMLButtonElement>, value: string): JSX.Element {
        let from = value[0] || ""
        let to = value[1] || ""

        value = from && to ? "از " + from + " ، تا " + to : from

        return (
            <button onClick={(e) => {
                setActiveDate("ChosenTime");
                openCalendar(e);
            }} className={activeData === "ChosenTime" ? "Filter-Button active" : "Filter-Button"}>
                {
                    value === "" ?
                        <>
                            <CalendarIcon/>
                            &nbsp;&nbsp;
                            انتخاب بازه زمانی
                        </>
                        :
                        value
                }
            </button>
        )
    }

    return (
        <div className="Range-Picker">
            <DatePicker
                className="red"
                range
                render={(value: string, openCalendar: MouseEventHandler<HTMLButtonElement>) => {
                    return CustomRangeInput(openCalendar, value)
                }}
                value={value}
                // minDate={new DateObject({calendar: persian}).set("date", value)}
                calendar={persian}
                locale={persian_fa}
                calendarPosition="bottom-left"
            />
        </div>
    )
}

export default RangePicker